export interface MethodPillProps {
  method: 'GET' | 'POST' | 'PUT' | 'PATCH' | 'DELETE' | 'HEAD' | 'OPTIONS';
  size?: 'sm' | 'md';
}

const METHOD_COLORS: Record<string, string> = {
  GET: 'var(--method-get)',
  POST: 'var(--method-post)',
  PUT: 'var(--method-put)',
  PATCH: 'var(--method-patch)',
  DELETE: 'var(--method-delete)',
  HEAD: 'var(--color-text-secondary)',
  OPTIONS: 'var(--color-text-secondary)',
};

// Fallback values if CSS vars are not defined
const METHOD_COLORS_FALLBACK: Record<string, string> = {
  GET: '#10B981',
  POST: '#3B82F6',
  PUT: '#F59E0B',
  PATCH: '#8B5CF6',
  DELETE: '#EF4444',
  HEAD: '#6B7280',
  OPTIONS: '#6B7280',
};

export function MethodPill({ method, size = 'md' }: MethodPillProps) {
  const color = METHOD_COLORS[method] ?? METHOD_COLORS_FALLBACK[method] ?? 'var(--color-text-secondary)';
  const fontSize = size === 'sm' ? 'var(--font-size-xs)' : 'var(--font-size-sm)';
  const padding = size === 'sm' ? '1px var(--spacing-1)' : '2px var(--spacing-2)';

  return (
    <span
      aria-label={`HTTP ${method}`}
      style={{
        display: 'inline-block',
        padding,
        fontSize,
        fontFamily: 'var(--font-family-mono)',
        fontWeight: 700,
        borderRadius: 'var(--radius-sm)',
        color,
        border: `1px solid ${color}`,
        background: 'var(--color-surface-background)',
        letterSpacing: '0.02em',
      }}
    >
      {method}
    </span>
  );
}
